import { render, staticRenderFns } from "./HomeRedirect.vue?vue&type=template&id=03fe5226&"
import script from "./HomeRedirect.vue?vue&type=script&lang=js&"
export * from "./HomeRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports